// extracted by mini-css-extract-plugin
module.exports = {"swatch":"InlineColorPicker_swatch__pIW2A","color":"InlineColorPicker_color__x3XDs","popover":"InlineColorPicker_popover__2xO0v","cover":"InlineColorPicker_cover__1Abs3"};